export function createCanvas() {
  if (typeof document !== 'undefined') {
    return document.createElement('canvas');
  } else {
    throw new Error('Cannot create a canvas in this context');
  }
}
//# sourceMappingURL=canvas.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g-webgpu/es/utils/canvas.js
// module id = null
// module chunks = 